import { OFFER_TYPE } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_TYPE.BOGO]: 'Compra 1, llévate 1',
  [OFFER_TYPE.FREE_ITEM]: 'Artículo gratis',
  [OFFER_TYPE.AMOUNT_OFF]: 'Importe descontado',
  [OFFER_TYPE.PERCENTAGE_OFF]: 'Porcentaje descontado',
};
